import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import {AiFillHome} from "react-icons/ai";
import ContactForm from '../../components/ContactForm/ContactForm';

const Appointment = () => {

    const mapLink = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2794.0956722854!2d-73.7493878!3d45.5583333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc9223c1a5b9b27%3A0x8f71f7c8e5a5c4d8!2s3025%20Boul.%20Tessier%2C%20Laval%2C%20QC%20H7S%201X1%2C%20Canada!5e0!3m2!1sen!2sus!4v1650000000000!5m2!1sen!2sus'

    return (
        <section className='appointment-section pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <div className="google-map">
                            <iframe title='map' src={mapLink}></iframe>

                            <div className="location-name">
                                <AiFillHome />
                                <p>3025 Boul. Tessier Suite 106, Laval</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <SectionTitle 
                            subTitle="BOOK APPOINTMENT"
                            title="Quality care at Loft Dentaire Laval"
                            description="Schedule an appointment with one of our specialists. We provide comprehensive dental care for you and your family in a comfortable environment."/>

                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;
